export enum DisplayConfigurationExtendedDisplayEnum {
    Footer = 'Footer',
    None = 'None',
  }